<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Subtype')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="det">
            <div class="mb-2 position-relative">
              <div class="multiselect-lbl" v-if="details.tenant_id">{{$t('Shop')}}</div>
              <multiselect
                v-model="details.shop_id"
                :options="shopsList"
                placeholder="Select shop"
                track-by="eid"
                label="name"
                :translate="false"
              ></multiselect>
            </div>

            <FloatingLabel :value="details.station" label="Station ID" size="sm" :readonly="true" />
            <FloatingLabel :value="details.serial" label="Serial" size="sm" :readonly="true" />
            <FloatingLabel :value="details.position" label="Position" size="sm" :readonly="true" />

            <b-form-group
              :label="$t('State')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >{{formattedState}}</b-form-group>

            <b-form-group :label="$t('Temporary offline')" class="grouping py-2 px-3 mb-3 mt-0">
              <b-form-checkbox
                v-model="details.temporary_offline"
                :value="true"
                :unchecked-value="false"
                :disabled="details.state != 0"
              >{{$t('Consider this slot offline for future reports')}}</b-form-checkbox>
            </b-form-group>

            <div style="text-align:right">
              <b-dropdown variant="success" right split :text="$t('Save')" @click="onSubmitDetails">
                <b-dropdown-item @click="saveAsNew">{{$t('Save As New')}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="eid && eid != '0'">
      <b-col cols="12">
        <b-card :header="$t('Slot Reports')" style="position:relative">
          <slot-reports :eslot_id="eid" :last_report="lastReport" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import SlotReports from "./component/SlotReports";

export default {
  name: "myslot",
  props: ["selectedeid"],
  components: {
    Multiselect,
    FloatingLabel,
    SlotReports
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    Promise.all([
      this.$store.dispatch("cache/fetch", "shops").catch(e => e)
    ]).finally(() => {
      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.newId = true;
      }
    });
  },
  data: function() {
    return {
      eid: "",
      details: {
        shop_id: "",
        station: "",
        serial: "",
        position: "",
        state: 0,
        temporary_offline: false
      },
      newId: false,
      lastReport: {
        mec_in: 0,
        mec_out: 0
      },
      addMode: true,
      temp: {}
    };
  },
  computed: {
    shopsList() {
      return this.$store.getters["cache/shops"];
    },
    formattedState() {
      switch (this.details.state) {
        case 0:
          return "Offline";
        case 1:
          return "Online";
        case 2:
          return "Online (counters errors)";
      }

      return "Unknown";
    }
  },
  methods: {
    loadData() {
      if (this.eid == "") {
        // new role; nothing to load
        return;
      }
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const shopByID = this.$store.getters["cache/shopByID"];

      this.$store
        .dispatch("slot/read", this.eid)
        .then(resp => {
          this.temp = resp.data;

          if (resp.data.eshop_id) {
            const shop = shopByID(resp.data.eshop_id);
            if (shop) {
              resp.data.shop_id = shop;
            }
          }

          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    saveAsNew() {
      this.eid = "";
      this.newId = true;
      this.onSubmitDetails();
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "slot/update";

      detailsData.eid = this.eid;
      if (detailsData.shop_id) {
        detailsData.eshop_id = detailsData.shop_id.eid;
        delete detailsData.shop_id;
      } else {
        detailsData.eshop_id = "";
      }
      delete detailsData.shop_id;

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Slot updated";
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";
      this.details.shop_id = r.shop_id;
      this.details.station = r.station;
      this.details.serial = r.serial;
      this.details.position = r.position;
      this.details.state = r.state;
      this.details.temporary_offline = r.temporary_offline;
      this.lastReport = r.last_report;
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
